import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Play, X } from 'lucide-react';
import './DemoTabs/DemoTabs.css';

const DEMO_VIDEO_URL = 'https://d3h5y5lv9ri89u.cloudfront.net/landing/website+video.mp4';

const DemoVideoButton = () => {
    const [showVideo, setShowVideo] = useState(false);

    useEffect(() => {
        if (showVideo) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }
        return () => {
            document.body.classList.remove('no-scroll');
        };
    }, [showVideo]);

    useEffect(() => {
        if (!showVideo) return;
        const onKeyDown = (e) => {
            if (e.key === 'Escape') setShowVideo(false);
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [showVideo]);

    return (
        <>
            <button
                className="demo-tabs__video-button"
                onClick={() => setShowVideo(true)}
            >
                <span className="demo-tabs__video-play">
                    <Play size={13} fill="currentColor" />
                </span>
                Watch demo
            </button>

            {showVideo && createPortal(
                <div className="demo-tabs__overlay" onClick={() => setShowVideo(false)}>
                    <div className="demo-tabs__modal" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="demo-tabs__close"
                            onClick={() => setShowVideo(false)}
                            aria-label="Close video"
                        >
                            <X size={22} />
                        </button>
                        <video
                            className="demo-tabs__video"
                            src={DEMO_VIDEO_URL}
                            controls
                            autoPlay
                            playsInline
                        />
                    </div>
                </div>,
                document.body
            )}
        </>
    );
};

export default DemoVideoButton;
